<template>
  <div>
    <el-card shadow="always" style="box-shadow:none">
      <EditForm
        ref="editForm"
        v-if="!showSpuDetail"
        :evgSpuCode="evgSpuCode"
        :evgSpuStatus.sync="evgSpuStatus"
        :optType="pageType"
        @reload="reload"
      />
      <SpuDetail
        ref="spuDetail"
        v-if="showSpuDetail"
        :evgSpuCode="evgSpuCode"
        :evgSpuStatus.sync="evgSpuStatus"
        :optType="pageType"
      ></SpuDetail>
    </el-card>
    <el-card
      shadow="always"
      style="box-shadow:none"
      v-if="evgSpuStatus === 'Y'"
      class="mt-2"
    >
      <SkuTable
        ref="skuTable"
        :evgSpuCode="evgSpuCode"
        :disabled="pageType !== 'addSku'"
      />
    </el-card>
  </div>
</template>
<script>
import EditForm from '../components/edit-form'
import SkuTable from '../components/sku-table'
import SpuDetail from '../components/spu-detail'
export default {
  name: 'ecom-base-evgspu-detail',
  components: { EditForm, SkuTable, SpuDetail },
  data() {
    return { evgSpuStatus: '', showSpuDetailLabel: ['detail', 'addSku'] }
  },
  computed: {
    params() {
      return this.$route.params
    },
    pageType() {
      return this.params.pageType
    },
    evgSpuCode() {
      return this.params.evgSpuCode
    },
    showSpuDetail() {
      return this.showSpuDetailLabel.includes(this.pageType)
    },
  },
  methods: {
    reload() {
      this.$refs.skuTable.getData()
    },
  },
}
</script>
